import React, {Suspense} from 'react';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import {WebviewUtils} from '@shared/webviewUtils';
import DiagCpoRecall from '@di-shared/features/diag/cpo/recall/DiagCpoRecall';
import DiagCpoRecallLoading from '@di-shared/features/diag/cpo/recall/DiagCpoRecallLoading';
import {t} from '@di-shared/features/common/useInferableTranslation';

interface DiagCpoRecallPageProps {
  vin: string;
}

function linkToMaintenanceAppointment(vin: string) {
  WebviewUtils.openNewWebView({
    url: `${import.meta.env.VITE_CCI_DOMAIN}/maintenance/register/appointment?vin=${vin}`,
    isModal: true,
    isNavigationBar: true,
    isToolBar: false,
  });
}

function DiagCpoRecallPage({vin}: DiagCpoRecallPageProps) {
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T30384')}</h1>
      </Header>
      <main
        id="content"
        className="content page_car_management"
      >
        <Suspense fallback={<DiagCpoRecallLoading />}>
          <DiagCpoRecall vin={vin} />
        </Suspense>
      </main>

      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={() => linkToMaintenanceAppointment(vin)}
        >
          {t('T30372')}
        </button>
      </div>
    </div>
  );
}

export default DiagCpoRecallPage;
